const det_bottom =
    <>
        <p>Found a bug or have additions?</p>
        <p>Please let me know {'->'} <b><a target='_blank' rel="noreferrer" href="https://t.me/remapru_bot">telegram-bot</a></b></p>
    </>

const sb_bottom =
    <>
        <span className='p-2 '>We haven't added protests for this period yet ;(</span>
        <p>Know about the protest? Write {'->'}
            <b><a target='_blank' rel="noreferrer" href="https://t.me/remapru_bot">telegram-bot</a></b>
        </p>
    </>

const sb_bottom2 =
    <>
        <p>
            During this period, the protests ended.
        </p>
        <p>
            To see more protests, select a different period.
        </p>
    </>

export const en = {
    name: 'en',
    title: 'English',
    header: {
        title: 'Chronicle of protests in Russia',
        join_button: 'Join',
        map_button: 'Map',

    },
    join_page: {
        group_list: {
            title: 'List of protest groups',
            desc: 'Choose the right group by interests and geolocation',
            footer: ' You a group and want to join our list? -> @remapru_bot',
        },
        send_protests_us: {
            title: 'Send protests to us',
            desc: 'Help in filling the resource is a huge contribution',
            text: '',
        }
    },
    main_page: {
        apply: 'Apply',
        side_bar:{
            navigation:{
                news_list: 'Protests list',
                news_mob_list: 'Protests',
                archive: 'Archive',
                map: 'Map',
                more: 'More',
                less: 'Less',
            },
            list:{
                more: 'More',
                url: 'Source',
                no_url: 'No source',
            },
            det_bottom: det_bottom,
            archive: {
                title: 'Protest archive',
                week: 'week',
            },
            sb_bottom: sb_bottom,
            sb_bottom2: sb_bottom2,

        }
    }
}

